import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';

class DropDownChonKetQuaXuLy extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label} options={this.props.data} keyName='giaTri' valueName='ten' 
      onChange={this.onChange.bind(this)} placeholder className={this.props.className} />
    )
  }
}

DropDownChonKetQuaXuLy.defaultProps = {
  label: 'Tình trạng xử lý',
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.huongXuLyDon
  }
}

export default connect(bindStateToProps)(DropDownChonKetQuaXuLy);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonketquaxuly.jsx